export default __webpack_public_path__ + "static/media/StepClone1.32ab54ac.gif";